import { create } from 'zustand';

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed'; platform: string }>;
}

interface InstallStore {
  deferred: BeforeInstallPromptEvent | null;
  installed: boolean;
  setDeferred: (e: BeforeInstallPromptEvent | null) => void;
  markInstalled: () => void;
}

function detectStandalone(): boolean {
  if (typeof window === 'undefined') return false;
  if (window.matchMedia?.('(display-mode: standalone)').matches) return true;
  return Boolean((window.navigator as unknown as { standalone?: boolean }).standalone);
}

/**
 * Global capture of the `beforeinstallprompt` event.
 * The event is dispatched ONCE early in page life — before any code-split route
 * has had a chance to mount its own listener — so we keep this store at App root
 * and let Settings read from it.
 */
export const useInstallStore = create<InstallStore>((set) => ({
  deferred: null,
  installed: detectStandalone(),
  setDeferred: (deferred) => set({ deferred }),
  markInstalled: () => set({ installed: true, deferred: null }),
}));
